import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDl3GaCQNZEwlpYp4d3sBDYzgsmRdskxbE",
  authDomain: "xenya-app.firebaseapp.com",
  projectId: "xenya-app",
  storageBucket: "xenya-app.firebasestorage.app",
  messagingSenderId: "1098647608082",
  appId: "1:1098647608082:web:6db224888ed63c59c6f1cb",
  measurementId: "G-R0YFWMW4G2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

export { app, auth, db, functions };